
import * as charitableActivityConstants from './actionTypes';
import request from './Request';
import constants from '../../config/constants';
import moment from 'moment';
import axios from 'axios';
import {utils,writeFile} from 'xlsx';

export const getCharitableActivityList = (limit,page,filter,search) => {
  const businessId = filter?.filterByBusinessUnit?.map(item => item.value) || '';
  const location = filter?.filterByBusinessUnitLocation?.map(item => item.value) || '';
  const startDate = filter?.startDate ? moment(filter?.startDate).format('YYYY-MM-DD')  : '';
  const endDate = filter?.endDate ? moment(filter?.endDate).format('YYYY-MM-DD')  : '';
  const charityName = filter?.charityName || '';
  const activityName = filter?.activityName || '';
  const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));



  return (dispatch) => {
    dispatch({
      type: charitableActivityConstants.FETCH_CHARITY_ACTIVITY_LIST
    });
    request({
        method: 'get',
        headers:{
          "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
        },
        url: `${constants.BASE_URL}charitableEvent/get/${userDetails?.userId}?filterByStartDate=${startDate}&filterByEndDate=${endDate}&filterByBusinessUnit=${businessId || ''}&filterByBusinessUnitLocation=${location}&charityNameSearch=${charityName}&activityNameSearch=${activityName}`,
        // url: `${constants.BASE_URL}charitableEvent/get/${userDetails?.userId}?filterByStartDate=${startDate}&filterByEndDate=${endDate}&filterByBusinessUnit=${businessId || ''}&filterByBusinessUnitLocation=${location}`,
        params: {
          search:  search || '',
          limit,
          page,
      }
    })
      .then((response) => {
        dispatch({
          type: charitableActivityConstants.FETCH_CHARITY_ACTIVITY_LIST_SUCCESS,
          payload: response.data
        });
      })
      .catch((error) => {
        dispatch({
          type: charitableActivityConstants.FETCH_CHARITY_ACTIVITY_LIST_FAILURE,
          payload:error?.response?.data
        });
      })
  }

}

export const getCharitableActivityDetails = (payload) => {
    return (dispatch) => {
      dispatch({
        type: charitableActivityConstants.FETCH_CHARITY_ACTIVITY_DETAILS
      });
        request({
            method: 'get',
            headers:{
              "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
            },
            url:`${constants.BASE_URL}charitableEvent/view?charitableEventId=${payload}`,
        })
        .then((response) => {
          dispatch({
            type: charitableActivityConstants.FETCH_CHARITY_ACTIVITY_DETAILS_SUCCESS,
            payload: response
          });
        })
        .catch((error) => {
          dispatch({
            type: charitableActivityConstants.FETCH_CHARITY_ACTIVITY_DETAILS_FAILURE,
            payload:error?.response?.data
          });
        })
    }
  
  }
  export const getBUnitFilterDetails = (payload) => {
    const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));

      return (dispatch) => {
        dispatch({
          type: charitableActivityConstants.FETCH_CHARITY_ACTIVITY_FILTER_LIST
        });
          request({
              method: 'get',
              headers:{
                "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
              },
              url:`${constants.BASE_URL}lov/businessUnitLocation/${userDetails?.userId}`,
          })
          .then((response) => {
            dispatch({
              type: charitableActivityConstants.FETCH_CHARITY_ACTIVITY_FILTER_LIST_SUCCESS,
              payload: response.data
            });
          })
          .catch((error) => {
            dispatch({
              type: charitableActivityConstants.FETCH_CHARITY_ACTIVITY_FILTER_LIST_FAILURE,
              payload:error?.response?.data
            });
          })
      }
    
    }
    export const getBUnitFilterDetailsPreload = (payload) => {
      const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));

          return request({
              method: 'get',
              headers:{
                "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
              },
              url:`${constants.BASE_URL}lov/businessUnitLocation/${userDetails?.userId}`,
          })
          .then((response) => {
            return response.data
          })
          .catch((error) => {
            return []
          })
    
    }
  export const createNewCharitableActivity = (payload) => {
  return (dispatch) => {
    dispatch({
      type: charitableActivityConstants.CREATE_CHARITY_ACTIVITY
    });
    axios({
      method: 'post',
      // headers:{
      //   "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
      // },
      url: `${constants.BASE_URL}charitableEvent/create`,
      headers: {
        "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
      },
      data : payload
    })
    .then((response) => {
        dispatch({
          type: charitableActivityConstants.CREATE_CHARITY_ACTIVITY_SUCCESS,
          payload: response.data
        });
    
    }).catch((error) => {
      dispatch({
        type: charitableActivityConstants.CREATE_CHARITY_ACTIVITY_FAILURE,
        payload:error?.response?.data
      });
    });
  }

}
export const updateCharitableActivity = (payload) => {
  return (dispatch) => {
    dispatch({
      type: charitableActivityConstants.UPDATE_CHARITY_ACTIVITY
    });
    axios({
      method: 'post',
      url: `${constants.BASE_URL}charitableEvent/update`,
      headers: {
        "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
      },
      data : payload
    })
  .then((response) => {
      dispatch({
        type: charitableActivityConstants.UPDATE_CHARITY_ACTIVITY_SUCCESS,
        payload: response.data
      });
  }).catch((error) => {
    dispatch({
      type: charitableActivityConstants.UPDATE_CHARITY_ACTIVITY_FAILURE,
      payload:error?.response?.data
    });
  });
}

}
export const deleteCharitableActivity = (data) => {
  return (dispatch) => {
      dispatch({
        type: charitableActivityConstants.DELETE_CHARITY_ACTIVITY,
      });
     
      request({
          method: 'post',
          headers:{
            "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
          },
          url:`${constants.BASE_URL}charitableEvent/delete/${data.id}`,   
          data: data
      })
      .then((response) => {
        dispatch({
          type: charitableActivityConstants.DELETE_CHARITY_ACTIVITY_SUCCESS,
          payload: response.data
        });
      })
      .catch((error) => {
        dispatch({
          type: charitableActivityConstants.DELETE_CHARITY_ACTIVITY_FAILURE,
          payload: error?.response?.data
        });
      })

  }
}
export const uploadFiles = (data) => {
  return (dispatch) => {
      dispatch({
        type: charitableActivityConstants.UPLOAD_FILES,
      });
     
      axios({
          method: 'post',
          url:`${constants.BASE_URL}charitableEvent/delete/${data.id}`,   
          data: data,
          headers: {
            "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
        }
      })
      .then((response) => {
        dispatch({
          type: charitableActivityConstants.UPLOAD_FILES_SUCCESS,
          payload: response.data
        });
      })
      .catch((error) => {
        dispatch({
          type: charitableActivityConstants.UPLOAD_FILES_FAILURE,
          payload: error?.response?.data
        });
      })

  }
}

export const uploadFilesToCloudStorage = async(files) => {
    if (files?.length === 0) return;
    // const uploadPromises = async() => {
      const formData = new FormData();
      files?.forEach((file, index) => {
        formData.append('files', file)
          });
        formData.append('bucketName', constants.FILE_UPLOAD_BUCKETNAME)
      try {
        const response = await axios.post(
          `${constants.FILE_UPLOADER_URL}/upload`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        console.log('File uploaded successfully:', response.data);
        return response.data
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    // };
  };

  export function exportReport(filter, translatedHeadings) {
    const businessId = filter?.filterByBusinessUnit?.map(item => item.value) || '';
    const location = filter?.filterByBusinessUnitLocation?.map(item => item.value) || '';
    const startDate = filter?.startDate ? moment(filter?.startDate).format('YYYY-MM-DD')  : '';
    const endDate = filter?.endDate ? moment(filter?.endDate).format('YYYY-MM-DD')  : '';
    const charityName = filter?.charityName || '';
    const activityName = filter?.activityName || '';

    const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));

    return (dispatch) => {
        dispatch({
            type: charitableActivityConstants.EXPORT_CHARITY_DATA,
        });
        request({
            method: 'get',
            headers:{
                "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
            },
            url: `${constants.BASE_URL}charitableEvent/export/${userDetails?.userId}?filterByStartDate=${startDate}&filterByEndDate=${endDate}&filterByBusinessUnit=${businessId || ''}&filterByBusinessUnitLocation=${location}&charityNameSearch=${charityName}&activityNameSearch=${activityName}`,
        }).then((response) => {
            const wb = utils.book_new();
            const ws = utils.json_to_sheet([{[translatedHeadings["Export Date"]]: new Date()}]);
            const defaultColumnWidth = { wpx: 60 };
            
            Object.keys(response?.data?.data[0] || {}).forEach(() => {
                ws['!cols'] = ws['!cols'] || [];
                ws['!cols'].push({ wch: defaultColumnWidth.wpx });
            });
            utils.sheet_add_json(ws,[{[translatedHeadings['Total Records']] : response.data.totalCount}],{origin: "A5"})
            utils.sheet_add_json(ws, response?.data?.data?.map((item) => {
                const csvdata = { 
                    [translatedHeadings["Activity Date"]]: moment(item.activityDate).format('MM/DD/YYYY'),
                    [translatedHeadings["Business Unit"]]: item.businessUnitName,
                    [translatedHeadings["Location"]]: item.businessUnitLocationName,
                    [translatedHeadings["Charity Name"]]: item.charityName,
                    [translatedHeadings["Activity Name"]]: item.activityName || 'NA',
                    [translatedHeadings["Martinrea Funds"]]: ((item?.currency?.toUpperCase()) + ' ' + new Intl.NumberFormat().format(item.martinreaFunds)) || 0.00,
                    [translatedHeadings["Employee Funds"]]: ((item?.currency?.toUpperCase()) + ' ' + new Intl.NumberFormat().format(item.employeeFund)) || 0.00,
                    [translatedHeadings["Volunteer Hours"]]: item.volunteerHours
                };
                return csvdata;
            }), { origin: "A8" });

            utils.book_append_sheet(wb, ws, 'Sheet1');
            writeFile(wb, `charitable-activity-report.xlsx`);
        })
        .catch((error) => {
            dispatch({
                type: charitableActivityConstants.EXPORT_CHARITY_DATA_FAILURE,
                payload: error
            });
        });
    }
}

  export const getRecentCharitableActivityList = (limit,page,filter,search) => {
    const businessId = filter?.filterByBusinessUnit?.map(item => item.value) || '';
    const location = filter?.filterByBusinessUnitLocation?.map(item => item.value) || '';
    const startDate = filter?.startDate ? moment(filter?.startDate).format('YYYY-MM-DD')  : '';
    const endDate = filter?.endDate ? moment(filter?.endDate).format('YYYY-MM-DD')  : '';
    const charityName = filter?.charityName || '';
    const activityName = filter?.activityName || '';
    const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));
  
    return (dispatch) => {
      dispatch({
        type: charitableActivityConstants.FETCH_RECENT_CHARITY_ACTIVITY_LIST
      });
      request({
          method: 'get',
          headers:{
            "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
          },
          url: `${constants.BASE_URL}dashboard/getKpi?limit=10&page=0`,
          params: {
            search:  search || '',
            limit,
            page,
        }
      })
        .then((response) => {
          dispatch({
            type: charitableActivityConstants.FETCH_RECENT_CHARITY_ACTIVITY_LIST_SUCCESS,
            payload: response.data
          });
        })
        .catch((error) => {
          dispatch({
            type: charitableActivityConstants.FETCH_RECENT_CHARITY_ACTIVITY_LIST_FAILURE,
            payload:error?.response?.data
          });
        })
    }
  
  }
  
  export const fetchGalleryDetails = (filter) => {
    const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));

    const businessId = filter?.filterByBusinessUnit?.map(item => item.value) || '';
    const location = filter?.filterByBusinessUnitLocation?.map(item => item.value) || '';
    const startDate = filter?.startDate ? moment(filter?.startDate).format('YYYY-MM-DD')  : '';
    const endDate = filter?.endDate ? moment(filter?.endDate).format('YYYY-MM-DD')  : '';
    const limit = Number(filter?.pagination?.limit) || 20;
    const offset = filter?.pagination?.offset || 1;
  

      return (dispatch) => {
        dispatch({
          type: charitableActivityConstants.FETCH_GALLERY_DETAILS
        });
          request({
              method: 'get',
              headers:{
                "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
              },
              url:`${constants.BASE_URL}dashboard/getGallery?limit=${limit}&page=${offset}&filterByStartDate=${startDate}&filterByEndDate=${endDate}&filterByBusinessUnit=${businessId}&filterByBusinessUnitLocation=${location}&filterByMediaType=${filter?.filterDropdown || "ALL"}`,
          })
          .then((response) => {
            dispatch({
              type: charitableActivityConstants.FETCH_GALLERY_DETAILS_SUCCESS,
              payload: response.data
            });
          })
          .catch((error) => {
            dispatch({
              type: charitableActivityConstants.FETCH_GALLERY_DETAILS_FAILURE,
              payload:error?.response?.data
            });
          })
      }
  }